import React from "react";

import DefaultLayout from "../src/layouts/DefaultLayout";
import { I18nProvider } from "../src/utils/localization/languages/I18nContext";
import { I18nProvider as LinguiProvider } from "@lingui/react";
import {
  setAdobeAnalyticsPageVariables,
  setAdobeAnalyticsGeolocationVariables
} from "../src/utils/analytics/adobe";
import { getCurrentGeolocation } from "../src/utils/localization/geolocation/geolocationLoader";
import { dispatchTrackingEvent } from "../src/utils/analytics";
import { isSSR } from "../src/utils/ssr";
import { activateI18n } from "./lingui";
import Modal from "react-modal";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const wrapPageElement = ({ element, props }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { language, trackingParams, modal = false } = props.pageContext as any;
  const i18n = activateI18n(language);

  if (modal) return <React.Fragment>{element}</React.Fragment>;

  if (!isSSR()) {
    Modal.setAppElement("#___gatsby");

    setAdobeAnalyticsPageVariables({
      language: language.ogLang,
      ...trackingParams
    });

    getCurrentGeolocation()
      .then(({ countryCode, market }) => {
        setAdobeAnalyticsGeolocationVariables({
          countryCode,
          market
        });
      })
      // we want to trigger page view even if the geolocation API failed
      .finally(() => {
        dispatchTrackingEvent("page-view-tracking-data-available");
      });
  }
  return (
    <LinguiProvider i18n={i18n}>
      <I18nProvider language={language}>
        <DefaultLayout {...props}>{element}</DefaultLayout>
      </I18nProvider>
    </LinguiProvider>
  );
};
